import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const WinnersModal = ({ isOpen, onClose, SpecialCategories, entries}) => {
  const [currentPage, setCurrentPage] = useState(1); // 1 for special events, 2 for winners
  const [specialWinners, setSpecialWinners] = useState([]);

  const getLegacyWinners = async () => {
    const result = await fetch(`${currentDomain()}/api/winners`);
    const data = await result.json();
    const winners = data.map(item => ({ id: item.award_id, carNum: item.car_number }));
    setSpecialWinners(winners);
  }

  
  useEffect(() => {
      getLegacyWinners();
    }, [isOpen]);


  const currentDomain = () => {
    //if location origin starts with localhost, return localhost:3001
    if (location.origin.startsWith('http://localhost')) {
      return 'http://localhost:3001';
    } else {
      return location.origin;
    }
  }

  const extractWinners = (entries, excludedCarNumbers = []) => {
    //Set of car numbers in special categories to exclude
    const excludedSet = new Set(excludedCarNumbers);


    // Group entries by class and order by class_priority
    const sortedEntries = [...entries].sort((a, b) => a.class_priority - b.class_priority);

    const grouped = sortedEntries.reduce((accumulator, entry) => {
      if (excludedSet.has(entry.car_number)) return accumulator; //if car number is in excluded set, skip
      if (entry.avg_score == null) return accumulator; // skip entries without score
      (accumulator[entry.class_name] ||= []).push(entry);
      return accumulator;
    }, {});

    const winners = {};
    Object.entries(grouped).forEach(([className, classEntries]) => {
      classEntries.sort((a, b) => {
        const scoreDiff = (b.avg_score || 0) - (a.avg_score || 0);
        if (scoreDiff !== 0) return scoreDiff;
        // tie-breaker: higher paint average
        return (b.paint_avg || 0) - (a.paint_avg || 0);
      });
      winners[className] = {
        first: classEntries[0] || null,
        second: classEntries[1] || null
      };
    });
    return winners;
  };

  const handleSpecialWinnerChange = (categoryId, carNumber) => {
    setSpecialWinners((prev) => {
      const list = [...prev];
      const carNum = parseInt(carNumber, 10);

      const idx = list.findIndex((item) => item && item.id === categoryId);
      if (idx >= 0) {
        list[idx] = { id: categoryId, carNum };
      return list;
      }

      return [...list, { id: categoryId, carNum }];
    });
  };

  const handleNext = () => {
    // Do Checking here
    specialWinners.forEach((num, index) => {
      const res = fetch(`${currentDomain()}/api/winners`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(num)
    });
  });

  console.log('Special Winners:', specialWinners);
  setCurrentPage(2);
};

  const handleBack = () => {
    setCurrentPage(1);
  };

  const getExcludedCarNumbers = () => {
    return specialWinners.map(item => item.carNum);
  };

  const regularWinners = currentPage === 2 ? extractWinners(entries, getExcludedCarNumbers()) : {};
  
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Background Overlay */}
          <div className="fixed inset-0 bg-black opacity-50"></div>

          {/* Modal Content */}
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-7xl w-full h-full overflow-y-auto">
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {currentPage === 1 ? 'Special Event Winners' : 'Class Winners'}
              </h2>
              <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                <FaTimes />
              </button>
            </div>

            {/* Page 1: Special Events */}
            {currentPage === 1 && (
              <div className="space-y-4">
                <p className="text-gray-600 mb-4">Enter the car numbers for special event winners:</p>
                {SpecialCategories && SpecialCategories.map((category) => (
                  <div key={category.id} className="flex items-center justify-between">
                    <label className="flex-1 text-sm font-medium text-gray-700">
                      {category.name}
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="999"
                      className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                      value={specialWinners.find((item) => item.id === category.id)?.carNum || ''}
                      onChange={(e) => handleSpecialWinnerChange(category.id, e.target.value)}
                      placeholder="##"
                    />
                  </div>
                ))}
              </div>
            )}

            {/* Page 2: Regular Winners */}
                  {currentPage === 2 && (
                    <div className="space-y-4">
                    <p className="text-gray-600 mb-4">Class winners (excluding special event winners):</p>
                    <div className="grid grid-cols-2 gap-4">
                      {Object.entries(regularWinners).map(([className, classWinners]) => (
                      <div key={className} className="border rounded p-3">
                        <h3 className="font-semibold text-lg mb-2">{className}</h3>
                        <div className="space-y-1">
                        {classWinners.first && (
                          <div className="flex justify-between">
                          <span className="font-medium">1st Place:</span>
                          <span>#{classWinners.first.car_number} {classWinners.first.year} {classWinners.first.make} {classWinners.first.model} - {classWinners.first.owner_first_name} {classWinners.first.owner_last_name} (Score: {parseFloat(classWinners.first.avg_score).toFixed(2)})</span>
                          </div>
                        )}
                        {classWinners.second && (
                          <div className="flex justify-between">
                          <span className="font-medium">2nd Place:</span>
                          <span>#{classWinners.second.car_number} {classWinners.second.year} {classWinners.second.make} {classWinners.second.model} - {classWinners.second.owner_first_name} {classWinners.second.owner_last_name} (Score: {parseFloat(classWinners.second.avg_score).toFixed(2)})</span>
                          </div>
                        )}
                        </div>
                      </div>
                      ))}
                    </div>
                    </div>
                  )}

                  {/* Modal Footer */}
            <div className="flex justify-between w-full mt-6">
              {currentPage === 2 && (
                <button
                  onClick={handleBack}
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                  Back
                </button>
              )}
              
              <div className="flex-1 flex justify-center">
                {currentPage === 1 ? (
                  <button
                    onClick={handleNext}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                  >
                    Next
                  </button>
                ) : (
                  <button
                    onClick={onClose}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                  >
                    Close
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WinnersModal;